const API_URL = process.env.REACT_APP_AI_PROCESSOR_URL || 'http://localhost:8081';
// Use env var if set to a non-placeholder value, otherwise fallback to relative /minio
const _minioUrl = process.env.REACT_APP_MINIO_URL || '';
const MINIO_URL = (_minioUrl && _minioUrl.startsWith('/')) ? _minioUrl : (_minioUrl || (window.location.origin + '/minio'));

export const aiApi = {
  // Enhance audio using the AI processor service
  enhanceAudio: async (audioBlob) => {
    const response = await fetch(`${API_URL}/process/stream?type=audio_enhance`, {
      method: 'POST',
      headers: {
        'Content-Type': 'audio/wav',
        'Transfer-Encoding': 'chunked',
      },
      body: audioBlob,
    });

    if (!response.ok) {
      throw new Error('Failed to enhance audio');
    }

    return response.blob();
  },

  // Create a subtitle job for an audio file
  createSubtitleJob: async (audioId) => {
    const response = await fetch(`${API_URL}/audio/${audioId}/subtitles`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Failed to create subtitle job');
    return response.json();
  },

  // Get subtitle job status
  getSubtitleStatus: async (audioId, jobId) => {
    const response = await fetch(`${API_URL}/audio/${audioId}/subtitles/${jobId}/status`);
    if (!response.ok) throw new Error('Failed to get subtitle status');
    return response.json();
  },

  // Get subtitle result (includes segments when done)
  getSubtitleResult: async (audioId, jobId) => {
    const response = await fetch(`${API_URL}/audio/${audioId}/subtitles/${jobId}`);
    if (!response.ok) throw new Error('Failed to get subtitle result');
    return response.json();
  },

  // Fetch subtitle JSON from URL (for posts that already have subtitle_url)
  fetchSubtitles: async (subtitleUrl) => {
    if (!subtitleUrl) throw new Error('No subtitle URL provided');
    // Prepend MINIO URL if subtitleUrl is relative
    let fullUrl;
    if (subtitleUrl.startsWith('http')) {
      fullUrl = subtitleUrl;
    } else if (subtitleUrl.startsWith('/')) {
      // Absolute path - use window.location.origin
      fullUrl = window.location.origin + subtitleUrl;
    } else {
      fullUrl = MINIO_URL + '/' + subtitleUrl;
    }
    const response = await fetch(fullUrl);
    if (!response.ok) throw new Error(`Failed to fetch subtitles: ${response.status}`);
    return response.json();
  },

  // Poll subtitle job until complete
  pollSubtitleJob: async (audioId, jobId, { maxAttempts = 60, intervalMs = 2000 } = {}) => {
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      const statusData = await aiApi.getSubtitleStatus(audioId, jobId);
      const status = statusData?.data?.status;

      if (status === 'done' || status === 'cached') {
        return aiApi.getSubtitleResult(audioId, jobId);
      }

      if (status === 'failed') {
        throw new Error(statusData?.data?.error || 'Subtitle job failed');
      }

      await new Promise(resolve => setTimeout(resolve, intervalMs));
    }
    throw new Error('Subtitle job timed out');
  },

  // Check if AI processor is available
  healthCheck: async () => {
    const response = await fetch(`${API_URL}/health`);
    return response.json();
  },
};
